<template>
  <div id="reqrefund">
    <div class="reqrefund-box">
      <div class="title1 m_b24">自助退款</div>
      <div class="title2 m_b24">（退款到账时间工作日下午6点之前，节假日顺正）</div>

      <div class="sscp m_b28 fs14">
        <div class="ds2">
          <div class="fs14 m_r10">所属产品：</div>
          <span class="padding1 bg1 color_w b_r4 ">MJ绘画</span>
        </div>
        <div class="ds2 ">
          <div>会员ID ：</div>
          {{ userInfo.uid }}
        </div>
      </div>

      <div class="zfje m_b28 fs14">
        <div class="m_r10">支付金额：</div>
        <span>{{ (detail.pay_money / 100) }}元</span>
      </div>

      <div class="hysc m_b28 fs14">
        <div class="m_r10">会员服务：</div>
        <div class="">
          <span class="color_10">{{ detail.vip_use_day }}天</span>
          <span class="color_c" v-if="detail.use_num >0">（扣除会员运营服务费1元，敬请海涵）</span>
<!--          <p class="m_t14 color_9">注册时间： {{ formatTimestamp(detail.pay_date) }}</p>-->
        </div>
      </div>
      <div class="hhcs m_b28 fs14">
        <div class="m_r10">创作次数：</div>
        <span class="color_11 m_r10">{{ detail.use_num }} 次</span><span
          class="color_9">（单次扣除费用{{ monovalent }}元/次）</span>
      </div>

      <div class="ktfy m_b28 fs14">
        <div>可退费用：</div>
        <template v-if=" detail.use_num>0">
          <span>{{ (detail.pay_money / 100) }}  - {{ detail.use_num }}*{{
              monovalent
            }} - 1 =</span>
          <span class="fs36 color_r m_t10px">{{ calculate()?calculate():0 }}</span><span
            class="color_r">元</span>
        </template>
        <template v-else>
          <span>{{ (detail.pay_money / 100) }}  - {{ detail.use_num }}*{{
              monovalent
            }} =</span>
          <span class="fs36 color_r m_t10px">{{ calculate()?calculate():0 }}</span><span
            class="color_r">元</span>
        </template>
      </div>

      <div class="tkyy m_b28 fs14">
        <div class="m_r10">退款原因：</div>
        <div class="box_right"><textarea v-model="reason" class="text" type="text" placeholder="必填"> </textarea></div>
      </div>

      <div class="sub_btn m_b28 fs14" @click="duration()">
        同意并申请退款
      </div>
      <p class="title3">（退款到账时间工作日下午6点之前，节假日顺延）</p>
      <div class=" interpret">
        <p class="jianju">
          问：会员时长是如何计算？
        </p>
        <div class="jianju">
          答：是从您最后一次成功支付的订单时间截止到当前的会员时长计算，不是从注册时间开始算！
        </div>

        <p class="jianju">
          问：使用次数如何计算？
        </p>
        <div>
          答：是从您成功支付后使用产品的次数开始算，免费会员的免费试用次数不计算在内！
        </div>
      </div>
    </div>

    <popup ref="instructions" type="center" @close="guide('须知',0)">
      <div class="instructions_box">
        <p>退款须知</p>
        <div>
          尊敬的客户：
        </div>
        <div class="ft_i2">
          本产品属虚拟会员服务，含数字内容访问权、
          专属功能使用权等非实体权益，依法不适用七天
          无理由退款规定‌，秉承用户至上理念，特开通退
          款申请通道：
        </div>
        <div class="ft_i2 color_11">
          7天内未使用本产品，全额退款！
        </div>
        <div class="ft_i2 color_r">
          已使用：扣除会员服务运营费1元+产品使用次数的费用
        </div>
        <div class="subBtn1" @click="guide('须知',0)">
          好的，我知道了
        </div>
      </div>
    </popup>
    <popup ref="erwemaSuccess" type="center" @close="guide('二维码',0)">
      <div class="erwemaSuccess">
        <div class="SuccessBox" v-if="isLogin">
          <img v-if="isSuccess" class="ReqrefundImg" src="./img/reqerfund/reqSuccess.png" alt="">
          <img v-if="!isSuccess" class="ReqrefundImg" src="./img/reqerfund/reqError.png" alt="">
          <div v-if="isSuccess" class="reqSucText">自助退款申请成功</div>
          <div v-if="!isSuccess" style="color: red;" class="reqSucText">您已申请过退款，请勿重复申请</div>
          <div class="reqSucTip">退款到账时间工作日下午6点之前，节假日顺延</div>
          <div class="closeBtn" @click="guide('二维码',0)">关闭页面</div>
        </div>
      </div>
    </popup>
    <popup ref="erwemaError" type="center" @close="guide('二维码',0)">
      <div class="erwemaError">
        <div class="errorBox" v-if="isLogin">
          <img class="ReqrefundImg" src="./img/reqerfund/reqError.png" alt="">
          <div class="reqSucText">暂无查到订单信息，无法申请退款</div>
          <div class="reqSucTip">可能引起的原因如下</div>
          <div class="reqSucTip">一、当前是微信登录，订单可能在账号内支付，点此<span
              @click="guide('登录',0)">切换账号登录</span>查询
          </div>
          <div class="reqSucTip">二、您可能在其他冒充我们的虚假平台支付，请把订单截图 <a
              @click="utils.openKefu()"
              target="_blank">点此联系并发给客服</a>再次确认!
          </div>
          <div class="closeBtn" @click="guide('首页',0)">关闭页面</div>
        </div>
      </div>
    </popup>
    <popup ref="LoginPanel" type="center">
      <div class="LoginPanel">
        <div class="LoginBox">
          <div class="logTit">请先登录</div>
          <div style="position:  relative" v-if="LogionSwitch">
            <img class="saoImg" v-if="LogionSwitch" :src="code_url" alt="">
            <div v-if="timerout" class="time_out_cover" flex-center @click="get_login_code"> 二维码已过期，点击刷新
            </div>
          </div>
          <div class="account" v-if="!LogionSwitch"><input v-model="form.phone" type="text" placeholder="请输入账号">
          </div>
          <div class="cipher" v-if="!LogionSwitch"><input v-model="form.password" type="password"
                                                          placeholder="请输入密码"></div>
          <div class="loginBtn" v-if="!LogionSwitch" @click="login()"> 登录</div>
          <div class="loginTipTex" v-if="LogionSwitch">微信登录扫码</div>
          <div class="loginTipTex LoginOth">或</div>
          <div class="loginTipTex LoginBlu" @click="toLogion()">点此{{ LogionSwitch ? '账号密码' : '微信扫码' }}登录
          </div>
        </div>
      </div>
    </popup>


  </div>

</template>

<script type="text/ecmascript-6">
import popup from '@/components/Popup.vue'
import utils from '@/utils/index.js'
export default {
  components: { popup, },
  data() {
    return {
      // kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      reason: '',// 输入框
      instructions: '',// 须知弹窗
      user_order: false,// 该用户是否有订单
      detail: { // 订单信息
        pay_money: 0,
        refund_money: 0,
        pay_date:Date.now(),
        use_num:0,
        vip_use_day:0,
      },// 输入框
      monovalent: 0.5,// 单价
      dayMonovalent: 1.5,// 单价
      isSuccess: true,//
      erwemaSuccess: null,//
      erwemaError: null,//

      LogionSwitch: true,//
      code_url: null,//
      str_uuid: null,//
      showCodeImg: null,//
      codeTimer: '',//
      is_scan: 0,//
      timerout: false,//
      pay_time: 0,//
      form: {
        phone: "",
        code: "",
        password: "",
        password2: ""
      },//
      LoginPanel: null,//
      timer: null,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  created() {
    this.getProfile()
  },
  methods: {
    //须知弹窗
// title弹窗名称 num 0关闭 1开启
    guide(title, num) {
      console.log('guide')
      if (title == '须知') {
        if (num == 0) {
          this.$refs.instructions.close()
        } else {
          this.$refs.instructions.show()
        }
      } else if (title == '二维码') {
        if (num == 0) {
          this.$refs.erwemaSuccess.close()
          this.$router.push('/')
        } else {
          this.$refs.erwemaSuccess.show()
        }
      } else if (title == '登录') {
        this.$refs.erwemaError.close()
        this.$refs.LoginPanel.show()
        this.get_login_code()
      } else if (title == '客服') {

      } else if (title == '首页') {
        this.$router.push('/')
      }
    },
    // 查询订单
    orderForm() {
      console.log('orderForm')
      this.$http.get(`/front/aimj/refund/`).then(res => {
        console.log('res',res)
        if (res.status == 200) {
          this.user_order = true
          this.detail = res.data
          // this.detail.refund_req_time = 0
          this.isSuccess = false
          if(Object.keys( this.detail ) == 0){
            this.$refs.erwemaError.show()
            return
          }
          if (res.data.refund_req_time == 0) {
            this.$refs.instructions.show()
          } else {
            this.$refs.erwemaSuccess.show()
          }
        }
      }).catch(err => {
        console.log('err',err)
        if (err.message == "未找到订单") {
          this.$refs.erwemaError.show()
        } else if (err.status == 500) {
          this.$message.error('系统错误，请及时联系客服！');
        }else {
          this.$message.error('系统错误，请及时联系客服！');
        }
      })
    },
    // 提交充值订单
    duration() {
      console.log('duration')
      if(!this.isLogin){
        this.$refs.LoginPanel.show()
        return
      }
      if (this.detail.refund_req_time != 0) {
        this.$message.warning('该订单审核中，请耐心等待！')
        return
      }
      if (this.reason.trim().length == 0) {
        this.$message.warning('请输入退款原因！');
        return;
      }
      this.$http.post(`/front/aimj/refund/`, {
        // id: this.userInfo.uid,
        id: this.detail.id,
        refund_money: this.calculate()*100,
        refund_remark: this.reason,
      }).then((res) => {
        console.log(res)
        if (res.status == 200) {
          this.isSuccess = true
          this.detail.refund_req_time = res.data.refund_req_time
          // this.$message.success('申请成功！');

          this.$refs.erwemaSuccess.show()
        }else{
          // this.$message.success(res.);
        }
      }).catch(err => {
        console.log(err)
        if (err.data.status == 401) {
          this.$message.error(err.message)
        } else if (err.data.status == 500) {
          this.$message.error('系统错误，请及时联系客服！');
        }
      })
    },
    // 总价计算
    calculate() {
      let money = 0
      money = (this.detail.pay_money / 100) - (this.detail.use_num * this.monovalent)
      if(this.detail.use_num >0){
        return money-1<=0?0:money - 1
      }else{
        return money<=0?0:money
      }
    },
    formatTimestamp(timestamp) {
      // 处理时间戳单位（兼容秒和毫秒）
      if (timestamp < 1e12) timestamp *= 1000;

      const date = new Date(timestamp);

      // 获取日期组件
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始需+1
      const day = date.getDate();

      // 获取时间组件并补零
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // 组合成目标格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    toLogion() {
      console.log(111)
      this.LogionSwitch = !this.LogionSwitch
    },
    login() {//登录

      let data = {
        phone: this.form.phone,
        password: this.form.password
      }
      this.$http.post('/front/auth/login/phone/', data).then(res => {
        if (res.status == '200') {
          this.$message({
            message: '登录成功！',
            type: 'success'
          });
          localStorage.setItem("token", res.data.token);
          this.clearFn();
          this.getProfile();
          this.$refs.LoginPanel.close()
          //重新刷新页面
        } else {
          console.log(res.message)
          this.$message({
            message: res.message,
            type: 'warning',
          })
        }
      }).catch(res => {
        console.log(2222)
        this.$message({
          message: res.message,
          type: 'warning'
        });
        this.clearFn();
      })
    },
    getProfile() {
      // 获取用户信息
      this.$http.get(`/front/user/profile/`,{
        params: {
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          this.orderForm()
        }
      }).catch(err => {
        // 没有获取 登录弹窗
        this.$refs.LoginPanel.show()
        this.get_login_code()
      })
    },
    get_login_code() {
      this.timerout = false
      this.pay_time = 0
      if (this.timer) {
        clearInterval(this.timer)
      }
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0
      let site_id = this.getCache("site_id") || 0

      let keyword = localStorage.getItem("keyword") || "";
      let invite_id = localStorage.getItem("invite_id") || 0;
      let params = {
        ad_account_id: ad_account_id,
        invite_id: invite_id,
        site_id: site_id,
        keyword: keyword,
        bd_vid: bd_vid,
        qhclickid: qhclickid,
        sourceid: sourceid
      }
      this.$http.get(`/front/wx/imagecode/?authorizer_appid=${APP_ID}`, {params: params}).then(res => {
        this.code_url = res.data.res_img;
        this.str_uuid = res.data.str_uuid;
        let timer = setTimeout(() => {
          this.showCodeImg = true;
          clearTimeout(timer);
        }, 400)
        this.getLoginInfo();
      })
    },
    getLoginInfo() {
      this.timerout = false
      this.timer = setInterval(() => {
        let bd_vid = this.getCache("bd_vid") || "";
        let qhclickid = this.getCache("qhclickid") || "";
        let sourceid = this.getCache("sourceid") || "";

        let href = location.href
        let ad_account_id = this.getCache("ad_account_id") || 0
        let site_id = this.getCache("site_id") || 0
        let keyword = this.getCache("keyword") || ""
        let timestamp = localStorage.getItem("timestamp") || 0;

        if (href.indexOf(MAIN_URLROOT) <= -1) {
          ad_account_id = ad_account_id || AD_AID
        }
        let params = {
          str_uuid: this.str_uuid,
          ad_account_id: ad_account_id,
          site_id: site_id,
          keyword: keyword,
          timestamp: timestamp,
          bd_vid: bd_vid,
          qhclickid: qhclickid,
          sourceid:sourceid
        }
        this.$http.get(`/front/wx/imagecodelogin/`, {params: params}).then((res) => {
          if (res.data.is_auth_wxa == 1 && res.data.user_id && res.data.token) {
            localStorage.setItem("token", res.data.token);

            // 执行 必应注册上报
            let msclkid = this.getCache("msclkid") || ""
            if(msclkid !== ""){
              window.uetq = window.uetq || [];window.uetq.push('event', 'signup', {});
              console.log("执行 必应注册上报", window.uetq)
            }
            this.$refs.LoginPanel.close()
            this.getProfile();
            clearInterval(this.timer);
            this.timer = null
          }
        })
        this.pay_time += 3;
        if (this.pay_time >= 60) {
          this.pay_time = 0;
          clearInterval(this.timer);
          this.timerout = true;
        }
      }, 3000)
    },
    clearFn() {
      this.coding = false;
      this.second = 60;
      clearInterval(this.timer);
    },


  }
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>


#reqrefund {

  //height: 100vh;
  display: flex;
  justify-content: center;
  //align-items: center;
  background-color: #d3cdcd;
  padding: 50px 0;
  overflow-y: auto;
  //box-sizing: border-box;

  .reqrefund-box {
    padding: 30px 20px;
    color: #000000;
    width: 600px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 6px;
    position: relative;

    .title1 {
      margin-bottom: 14px;
      text-align: center;
      font-size: 24px;
    }

    .title2 {
      margin-bottom: 20px;
      text-align: center;
      font-size: 14px;
      color: #999999;
    }

    .title3 {
      text-align: center;
      font-size: 14px;
      color: #999999;
    }

    .sscp {
      display: flex;
      justify-content: space-between;
      //margin-bottom: 14px;
    }

    .zfje {
      font-size: 14px;
      display: flex;

      span {
        color: #ff0000;

      }
    }


    .hysc {
      display: flex;
    }

    .hhcs {
      display: flex;
    }

    .ktfy {
      display: flex;
      align-items: flex-end;

      .m_t10px {
        //margin-top: 10px;
        margin: 0 6px -9px;
      }
    }

    .tkyy {
      display: flex;

      .box_right {
        flex: 1;

        .text {
          width: 100%;
          height: 80px;
          line-height: 1;
          padding: 10px 10px;
          border: 1px solid #e3e3e3;
          border-radius: 5px;
          background-color: #f6f6f6;
        }
      }
    }

    .sub_btn {
      width: 100%;
      height: 50px;
      background: #000;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .interpret{
      width: 100%;
      //height: 200px;
      background-color: #f6f6f6;
      border: 1px solid #e3e3e3;
      border-radius: 5px;
      font-size: 14px;
      padding: 14px 20px;
      margin-top: 25px;
      p{
      }
      div{
        color: #666;
      }
      .jianju{
        margin: 0 0 10px 0 ;

      }
    }
  }

  .instructions_box {
    width: 400px;
    background-color: #fff;
    border-radius: 8px;
    color: #000;
    padding: 26px 16px;
    font-size: 14px;

    p {
      text-align: center;
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 20px;
    }

    div {
      margin-bottom: 16px;
    }

    .subBtn1 {
      width: 100%;
      height: 50px;
      background: #000;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .conceal {
    width: 100%;
    height: 100%;
    background-color: #ffffffe0;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #fff;
    padding: 0 20px;

    .panel_left_title {
      font-size: 25px;
      color: black;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      img {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        margin-right: 10px;
      }
    }

    .panel_left_plas {
      color: black;
      font-size: 14px;
      margin-bottom: 50px;
    }

    .dingdanImg {
      width: 50px;
    }

    .conceal_btn {
      width: 100%;
      height: 50px;
      background: #000;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-top: 30px;
    }
  }

  .erwemaSuccess {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;

    .SuccessBox {
      width: 100%;
      height: 400px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      position: relative;
      //.ReqrefundImg{
      //  width: 100px;
      //  height: 100px;
      //}

      .reqSuccessImg {
        width: 30px;
        height: 30px;
      }

      .reqSucText {
        font-size: 18px;
        color: #33a954;
        margin-top: 30px;
      }

      .reqSucTextOth {
        color: #ff0000;
      }

      .reqSucTip {
        color: #cfcfcf;
        margin-top: 40px;
      }

      .closeBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000;
        color: #fff;
        border-radius: 6px;
        width: calc(100% - 30px);
        padding: 15px 0;
        position: absolute;
        bottom: 20px;
        cursor: pointer;
      }

      .logTit {
        font-size: 20px;
        color: #000;
      }

      .saoImg {
        width: 150px;
        height: 150px;
        margin: 20px 0;
      }

      .loginTipTex {
        color: #000;
        font-size: 16px;
      }

      .loginTipTexOth {
        margin: 20px 0;
      }

      .loginTipTexBlu {
        cursor: pointer;
        color: #0066ff;
      }
    }
  }

  .erwemaError {

    box-sizing: border-box;
    //padding: ;
    .errorBox {
      width: 400px;
      padding: 20px 20px;
      //height: 400px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      //align-items: center;
      position: relative;
      color: black;
      font-size: 16px;

      .ReqrefundImg {
        width: 40px;
        //height: 30px;
        margin: 0 auto;
      }

      .reqSucText {
        color: #ff2e00;
        padding: 30px 0;
        margin: 0 auto;
        font-weight: 700;
      }

      .reqSucTip {
        margin-bottom: 40px;
        color: #666666;
        line-height: 1.7;

        span {
          color: #1717ff;
          cursor: pointer;
        }

        a {
          color: #1717ff;
          cursor: pointer;
        }
      }


      .closeBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000;
        color: #fff;
        border-radius: 6px;
        padding: 15px 0;
        cursor: pointer;
      }
    }
  }

  .LoginPanel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    color: #000;

    .LoginBox {
      width: 100%;
      height: 400px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      position: relative;


      .logTit {
        font-size: 20px;
        color: #000;
      }

      .saoImg {
        width: 150px;
        height: 150px;
        margin: 20px 0 0;
      }

      .time_out_cover {
        position: absolute;
        top: 20px;
        left: 0;
        width: 150px;
        height: 150px;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.58);
        color: #fff;
        font-size: 15px;
        z-index: 10;

        &:hover {
          font-size: 16px;
          font-weight: bold;
        }

        display: flex;
        align-items: center;
        justify-content: center;
      }

      .account, .cipher {
        input {
          width: 255px;
          height: 40px;
          padding: 4px;
          border: 1px solid #c0c4cc;
          border-radius: 5px;
          font-size: 14px;
        }

        input::placeholder {
          font-size: 14px; /* 设置占位符字体大小 */
          color: #999; /* 可以同时设置占位符的颜色 */
        }
      }

      .account {
        input {
          margin: 30px 0 15px;
        }
      }

      .cipher {
        input {
          margin: 15px 0 30px;
        }
      }

      .loginBtn {
        width: 255px;
        height: 40px;
        background-color: black;
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
      }

      .loginTipTex {
        color: #000;
        font-size: 16px;
      }

      .LoginOth {
        margin: 20px 0;
      }

      .LoginBlu {
        cursor: pointer;
        color: #0066ff;
      }
    }
  }

  .b_r4 {
    border-radius: 4px;
  }

  .color_w {
    color: #fff;
  }

  .color_b {
    color: #000;
  }

  .color_r {
    color: #ff0000;
  }

  .color_c {
    color: #cccccc;
  }

  .color_9 {
    color: #999999;
  }

  .color_10 {
    color: #009900;
  }

  .color_11 {
    color: #0000ff;
  }

  .ft_i2 {
    text-indent: 2em;
    line-height: 26px;
  }

  .fs36 {
    font-size: 36px;
  }

  .fs24 {
    font-size: 24px;
  }

  .fs14 {
    font-size: 14px;
  }

  .ta_c {
    text-align: center;
  }

  .m_r10 {
    margin-right: 10px;
  }

  .m_t14 {
    margin-top: 14px;
  }

  .m_b28 {
    margin-bottom: 28px;
  }

  .m_b24 {
    margin-bottom: 24px;
  }

  .ds1 {
    display: flex;
    justify-content: space-between;
  }

  .ds2 {
    display: flex;
    align-items: center;
  }

  .padding1 {
    padding: 4px 10px;
  }

  .bg1 {
    background-color: black;

  }
}

</style>